import { Observable } from "rxjs";
import {
  FlyerPagePositionCopyPreviewResponse,
  FlyerPagePositionPreviewProductResponse,
  FlyerPagePositionPreviewResponse,
  FlyerPagePreviewResponse,
} from "../types/flyer-detail-page-preview-response/flyer-page-preview-response.interface";
import * as http from "../../../../../../../services/http.service";
import {
  FlyerDetailPagePreview,
  FlyerDetailPagePreviewPosition,
  FlyerDetailPagePreviewProduct,
} from "../types/flyer-detail-page-preview/flyer-detail-page-preview.interface";
import { ApprovalStatus } from "../../../../../../../types/approval-status/approval-status.type";
import { map } from "rxjs/operators";
import { IFlyerDetailPagePositionCopy } from "../../../../../types/flyer-detail-data/flyer-detail-page-position/flyer-detail-page-position.interface";

export function fetchPagePreview(pageId: number): Observable<FlyerDetailPagePreview> {
  return http
    .get<FlyerPagePreviewResponse>(`/pages/${pageId}/preview/`)
    .pipe(map(mapFlyerPagePreviewResponseToFlyerDetailPagePreview));
}

function mapFlyerPagePreviewResponseToFlyerDetailPagePreview(
  response: FlyerPagePreviewResponse
): FlyerDetailPagePreview {
  return {
    pageId: response.id,
    flyerId: response.flyer,
    templateId: response.pageTemplate,
    numberOfPositions: response.totalPositions,
    notes: response.notes,
    status: response.status as ApprovalStatus,
    theme: response.theme,
    flyerName: response.flyerName,
    updatedAt: new Date(response.updatedAt),
    label: response.label,
    owner: response.owner,
    positions: response.positions.map(
      mapFlyerPagePositionPreviewResponseToFlyerPagePreviewPosition
    ),
  };
}

function mapFlyerPagePositionCopyPreviewResponseToFlyerPagePositionCopy(
  copy: FlyerPagePositionCopyPreviewResponse
): IFlyerDetailPagePositionCopy {
  return {
    id: copy.id,
    getCopyCard: copy.getCopyCard || "",
    copyCard: copy.copyCard || "",
    language: copy.language,
    brandLogo: copy.brandLogo || "",
    getProductImage: copy.getProductImage || "",
    productImage: copy.productImage || "",
  };
}

function mapFlyerPagePositionCopiesPreviewResponseToFlyerPagePositionCopies(
  copies: FlyerPagePositionCopyPreviewResponse[]
): IFlyerDetailPagePositionCopy[] {
  return copies.map(mapFlyerPagePositionCopyPreviewResponseToFlyerPagePositionCopy);
}

function mapFlyerPagePositionPreviewResponseToFlyerPagePreviewPosition(
  response: FlyerPagePositionPreviewResponse
): FlyerDetailPagePreviewPosition {
  return {
    id: response.id,
    pageId: response.page,
    templatePositionId: response.templatePosition.id,
    name: response.name,
    endAt: response.endAt || "",
    startAt: response.startAt || "",
    categories: response.categories,
    categoryDetails: response.categoryDetails,
    copies: mapFlyerPagePositionCopiesPreviewResponseToFlyerPagePositionCopies(response.copies),
    products: response.products
      ? response.products.map(
          mapFlyerDetailPagePreviewProductResponseToFlyerDetailPagePreviewProduct
        )
      : [],
  };
}

function mapFlyerDetailPagePreviewProductResponseToFlyerDetailPagePreviewProduct(
  response: FlyerPagePositionPreviewProductResponse
): FlyerDetailPagePreviewProduct {
  return {
    active: response.productDetail.active,
    name: response.productDetail.name,
    sku: response.productDetail.sku,
    buyGetStatus: response.buyGetStatus,
    image: response.productDetail.image ?? "",
    subcategory: response.productDetail.subcategory,
  };
}
